import { Component, OnInit, AfterViewInit } from '@angular/core';
import { RedirectRequestHandler } from '@openid/appauth';
import { AuthorizationService } from '../authorization.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'app-callbacks',
    templateUrl: './callbacks.component.html',
    styleUrls: ['./callbacks.component.css']
})
export class CallbacksComponent implements OnInit {
    constructor(public authorizationService: AuthorizationService, public router: Router, private spinner: NgxSpinnerService) { }

    ngOnInit() {
        if (!window.location.hash || window.location.hash.length === 0) {
            if (localStorage.getItem('isSignInLoading')) {
                localStorage.removeItem('isSignInLoading');
                this.authorizationService.isSignInLoading = true;
                this.spinner.show();
            }
            const queryString = window.location.search.substring(1);
            if (queryString.length > 0) {
                const path = [window.location.pathname, queryString].join('#');
                window.location.assign(new URL(path, window.location.href).toString());
            } else {
                this.navigateProductFamily();
            }
        } else if (new URLSearchParams(window.location.hash.substring(1)).has('code')) {
            this.authorizationService.isSignInLoading = true;
            this.spinner.show();
            this.authorizationService.completeAuthorizationRequest().then((tokenResponse) => {
                window.localStorage.setItem('authorization.service.token_response', JSON.stringify(tokenResponse))
                localStorage.setItem('authorization.service.isToken', 'true');
                let respo = JSON.parse(localStorage.getItem("authorization.service.token_response"))
                let filterResponse = {}
              filterResponse["token"] = respo["accessToken"]              
              filterResponse["isAdmin"] = window.localStorage.getItem('isAdmin')
              filterResponse["expires"] = respo["expiresIn"]
              localStorage.setItem("app_token", JSON.stringify(filterResponse));
                this.spinner.hide();
                this.authorizationService.isSignInLoading = false;
              localStorage.setItem('authorization.service.isToken', 'true');
              localStorage.removeItem('isAdmin');
                this.router.navigate(['productfamily']);
            });
        } else {
            this.navigateProductFamily();
        }
    }

    navigateProductFamily() {
        this.spinner.hide();
        this.authorizationService.isSignInLoading = false;
        this.router.navigate(['productfamily']);
    }
}



// WEBPACK FOOTER //
// ./src/app/callback/callbacks.component.ts